import { useMutation, useQuery } from '@tanstack/react-query';
import type { MetaRequest } from '../model';
import type {
  UsersAgreementRequest,
  UsersChangePasswordRequest,
  UsersCreateRequest,
  UsersCreateResponse,
} from './users.model';
import {
  getUsersCurrent,
  getUsersDetail,
  getUsersHead,
  getUsersList,
  postUsersCreate,
  putUsersAgreement,
  putUsersChangePassword,
} from './users.service';

export const useGetUsersCurrent = (payload?: MetaRequest) => {
  return useQuery({
    queryKey: ['users', 'current'],
    queryFn: async () => getUsersCurrent(payload),
  });
};

export const useGetUsersDetail = (id?: string) => {
  return useQuery({
    queryKey: ['users', 'detail', id],
    queryFn: async () => getUsersDetail(id),
    enabled: !!id,
  });
};

export const useGetUsersHead = (id?: string) => {
  return useQuery({
    queryKey: ['users', 'head', id],
    queryFn: async () => getUsersHead(id),
    enabled: !!id,
  });
};

export const useGetUsers = (payload?: MetaRequest) => {
  return useQuery({
    queryKey: ['users', ...Object.values(payload ?? {})],
    queryFn: async () => getUsersList(payload),
  });
};

export const usePostUsersCreate = () => {
  return useMutation<UsersCreateResponse, Error, UsersCreateRequest>({
    mutationFn: async (payload) => postUsersCreate(payload),
  });
};

export const usePutUsersChangePassword = () => {
  return useMutation<UsersCreateResponse, Error, UsersChangePasswordRequest>({
    mutationFn: async (payload) => putUsersChangePassword(payload),
  });
};

export const usePutUsersAgreement = () => {
  return useMutation<unknown, Error, UsersAgreementRequest>({
    mutationFn: async (payload) => putUsersAgreement(payload),
  });
};
